/*
Author: LiuBo
Date: 2018-09-05
Desc: 框架公用方法
*/
import conf from "@/config/index";
import cryptoJS from "@/assets/js/aes";
import cache from "@/assets/js/cache";
// eslint-disable-next-line camelcase
import { encrypt_ECB } from "@/util/sm4";

export default {
    /* 获取/src/config/下的配置信息
  @inParam 无
  @return [Object] 配置对象，详见/src/config/config.js
  */
    getConfig() {
        return conf;
    },

    /* 获取CMS的模块化配置参数
  @inParam '业务模块: 个人开户(0A1)、增卡(0A3)、删卡(0B6)、账户资料修改(0B1)启用标识
  @return true-展示  false-不展示
  */
    getBusinessModule(moduleName) {
        if (
            cache.getParamValue("business_module") &&
            cache.getParamValue("business_module").bizenable[moduleName] == false
        ) {
            return false;
        } else {
            return true;
        }
    },

    /* 获取CMS配置的是否支持展示柜台增的卡
  @inParam 无
  @return true-展示  false-不展示
  */
    showCounterCard() {
        if (
            cache.getParamValue("account_info") &&
            cache.getParamValue("account_info").showcountercard
        ) {
            return cache.getParamValue("account_info").showcountercard;
        } else {
            return true;
        }
    },

    /* 获取CMS配置的当前客户为 0-公募 或 1-私募
  @inParam 无
  @return 0-公募 或 1-私募
  */
    getFundClass() {
        if (cache.getParamValue("fund_market") && cache.getParamValue("fund_market").fundclass) {
            return cache.getParamValue("fund_market").fundclass;
        } else {
            return "0";
        }
    },

    /* 获取CMS配置的参数信息
  @inParam moduleName
  @return boolean
  */
    getFundTrans(moduleName) {
        if (
            cache.getParamValue("fund_trans") &&
            cache.getParamValue("fund_trans")[moduleName] == false
        ) {
            return false;
        } else {
            return true;
        }
    },

    /* 获取系统参数通用方法
  @inParam paramid
  @return paramvalue
  */
    getParamValue(paramid) {
        const params = cache.getParams();
        return params[paramid] && params[paramid].paramvalue ? params[paramid].paramvalue : "";
    },

    /* 获取CMS配置的展示菜单下对应的子模块的配置信息
  @inParam moduleid-子模块对应的编号
  @return true-展示  false-不展示
  */
    checkModuleid(moduleid) {
        const menuModule =
            (cache.getParamValue("menu_module") && cache.getParamValue("menu_module").menus) || [];
        const getAllModuleIds = (data) => {
            const moduleIds = [];
            const traverse = (items) => {
                items.forEach((item) => {
                    // 如果当前项有 moduleid，则收集
                    if (item.moduleid) {
                        moduleIds.push(item.moduleid);
                    }
                    // 递归遍历 menu 和 menumodule（如果存在）
                    if (item.menu) {
                        traverse(item.menu);
                    }
                    if (item.menumodule) {
                        traverse(item.menumodule);
                    }
                });
            };

            traverse(data);
            return moduleIds;
        };

        if (menuModule.length > 0) {
            const allModuleIds = getAllModuleIds(menuModule);
            if (allModuleIds.includes(moduleid)) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    },

    getMenuName(menuid, menuname) {
        const menuModule =
            (cache.getParamValue("menu_module") && cache.getParamValue("menu_module").menus) || [];

        let targetMenu = [];
        menuModule.forEach((item) => {
            if (item.menuid == menuid) {
                targetMenu = item;
            }

            if (item.menu && item.menu.length > 0) {
                item.menu.forEach((subItem) => {
                    if (subItem.menuid == menuid) {
                        targetMenu = subItem;
                    }
                });
            }
        });

        return targetMenu.menuname || menuname;
    },

    /* 获取菜单信息
    @inParam [String] menuid 菜单ID
    @return [Object] 菜单信息对象
    */
    getMenuItem(menuid) {
        const menuModule =
            (cache.getParamValue("menu_module") && cache.getParamValue("menu_module").menus) || [];

        let targetMenu = {};
        menuModule.forEach((item) => {
            if (item.menuid == menuid) {
                targetMenu = item;
            }

            if (item.menu && item.menu.length > 0) {
                item.menu.forEach((subItem) => {
                    if (subItem.menuid == menuid) {
                        targetMenu = subItem;
                    }
                });
            }
        });

        return targetMenu;
    },

    /* 迭代生成器，详见 ES6 API
  @inParam [Array] 需要迭代的数组
  @return [Object] 迭代器对象，可通过 [Object].next() 访问数组下一项，详见 ES6 API
  */
    *iterator(ary) {
        for (let i = 0; i < ary.length; i++) {
            yield ary[i];
        }
    },

    /* AES 加密
  @inParam [String] 要加密的值
  @return [String] 加密后的值
  */
    enc(str) {
        // 查看柜台是否开启国密 CMS配置 0-国密
        const isSM4 = cache.getCompanyInfoParam("10102028") === "0";
        if (isSM4) {
            return encrypt_ECB(str);
        } else {
            let k = conf.encKey;
            let srcs = cryptoJS.enc.Utf8.parse(str);
            let key = cryptoJS.enc.Utf8.parse(k);
            let iv = cryptoJS.enc.Utf8.parse(k);
            let encrypted = cryptoJS.AES.encrypt(srcs, key, {
                iv: iv,
                mode: cryptoJS.mode.CBC
            });
            return encrypted.toString();
        }
    },
    /* 对字符串转义以防止跨站脚本攻击
  @inParam [String] 要转义的字符串
  @return [String] 转义后的字符串
  */
    xss(str) {
        if (!str) return "";
        str = String(str);
        str = str.replace("<", "&lt;");
        str = str.replace(">", "&gt;");
        str = str.replace("'", "&apos;");
        str = str.replace('"', "&quot;");
        return str;
    },
    // -----------以下为表单验证方法，用于页面上validator 类型的校验-----------------
    /* 校验表单手机号信息
   @inParam [Object] rule 校验规则信息
   @inParam [String] value 获取到的校验项值
   @inParam [Object] callback 校验后回调函数
   */
    validateMobile(rule, value, callback) {
        if (value === "") {
            return callback(new Error("请输入手机号码"));
        }
        if (rule.regular ? rule.regular.test(value) : /^(1)(\d{10})$/.test(value)) {
            callback();
        } else {
            callback(new Error("手机号码输入不正确"));
        }
    },
    /* 校验邮政编码
    @inParam [Object] rule 校验规则信息
    @inParam [String] value 获取到的校验项值
    @inParam [Object] callback 校验后回调函数
    */
    validatePostCode(rule, value, callback) {
        if (value === "") {
            callback(new Error("请输入邮政编码"));
        }
        const reg = /^\d{6}$/;
        if (reg.test(value)) {
            callback();
        } else {
            callback(new Error("邮政编码输入不正确"));
        }
    },
    /* 校验邮箱地址
    @inParam [Object] rule 校验规则信息
    @inParam [String] value 获取到的校验项值
    @inParam [Object] callback 校验后回调函数
    */
    validateEmail(rule, value, callback) {
        if (value === "") {
            callback(new Error("请输入邮箱"));
        }
        const reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        if (reg.test(value)) {
            callback();
        } else {
            callback(new Error("邮箱输入不正确"));
        }
    },
    /* 校验脱敏的邮箱地址
    @inParam [Object] rule 校验规则信息
    @inParam [String] value 获取到的校验项值
    @inParam [Object] callback 校验后回调函数
    */
    validateDesEmail(rule, value, callback) {
        if (value === "") {
            callback(new Error("请输入邮箱"));
        }
        const reg = /^[a-zA-Z0-9_*-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        if (reg.test(value)) {
            callback();
        } else {
            callback(new Error("邮箱输入不正确"));
        }
    },
    maskPhoneNumber(phoneNumber) {
        if (typeof phoneNumber !== "string") {
            phoneNumber = phoneNumber.toString();
        }
        return phoneNumber.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
    },
    /* 校验电话号码或传真号码
    @inParam [Object] rule 校验规则信息
    @inParam [String] value 获取到的校验项值
    @inParam [Object] callback 校验后回调函数
    */
    validateFaxNum(rule, value, callback) {
        if (value === "") {
            callback(new Error("请输入号码"));
        }
        if (value.includes("*")) {
            callback();
        }
        const reg = /^[0-9]+[0-9]*$/;
        if (value !== "" && !reg.test(value)) {
            callback(new Error("号码输入不正确"));
        } else {
            callback();
        }
    },
    /* 校验是否为英文字母
    @inParam [Object] rule 校验规则信息
    @inParam [String] value 获取到的校验项值
    @inParam [Object] callback 校验后回调函数
    */
    validateChar(rule, value, callback) {
        if (value === "") {
            callback();
        }
        const reg = /^[a-zA-Z0-9\s]+$/;
        if (!(reg.test(value) && value.trim() !== "")) {
            callback(new Error("只能输入英文字母及数字"));
        } else {
            callback();
        }
    },
    /* 校验是否为大于0的正整数
    @inParam [Object] rule 校验规则信息
    @inParam [String] value 获取到的校验项值
    @inParam [Object] callback 校验后回调函数
    */
    validateInt(rule, value, callback) {
        if (value === "") {
            callback();
        }
        const reg = /^[1-9]*[1-9][0-9]*$/;
        if (!reg.test(value)) {
            callback(new Error("只能输入大于0的正整数"));
        } else {
            callback();
        }
    },
    /* 校验是否为标识符(只允许字母、数字和下划线)
    @inParam [Object] rule 校验规则信息
    @inParam [String] value 获取到的校验项值
    @inParam [Object] callback 校验后回调函数
    */
    validateIdentifier(rule, value, callback) {
        if (value === "") {
            callback();
        }
        const reg = /^\w+$/;
        if (!reg.test(value)) {
            callback(new Error("只能输入字母、数字或下划线"));
        } else {
            callback();
        }
    },
    /* 获字符串过滤
  @param [String] val 过滤值
  @return [String] 过滤后的字符串
  */
    filterCode(val) {
        return val.replace(/[^\u4e00-\u9fa5\w()]/g, "");
    },
    /* 获取页面URL参数
        /*入参  str[String] 字符串格式的URL路径，可选，如不提供默认取当前页面URL
        /*返回  [object] url参数键值对，key为参数名，value 为参数值
        /********************************************************************/
    getUrlParams(str) {
        str = decodeURI(str || location.href);
        let idx = str.indexOf("?");
        let params = {};
        let ary = [];
        if (idx != -1) {
            str = str.substring(idx + 1, str.length);
            ary = str.split("&");
            for (let i = 0; i < ary.length; i++) {
                let _idx = ary[i].indexOf("=");
                params[ary[i].substring(0, _idx)] = decodeURIComponent(
                    ary[i].substring(_idx + 1, ary[i].length)
                );
            }
        }
        return params;
    },
    convertArrToObj(arr, key1, key2) {
        // [{"key1":"val1","key2":"val2"},...] => {"val1":"val2,...}
        if (!(arr instanceof Array)) {
            return {};
        }
        let obj = {};
        arr.forEach((item) => {
            if (!item[key1] || !item[key2]) {
                return {};
            }
            obj[item[key1]] = item[key2];
        });
        return obj;
    },
    initAddrCascaderOps() {
        let options = [];
        let provinces = cache.getDict("190021") || [];
        let citylists = JSON.parse(
            JSON.stringify(cache.get("address")["citylists"])
                .replace(/cityid/g, "value")
                .replace(/cityname/g, "label")
        );
        let countylists = JSON.parse(
            JSON.stringify(cache.get("address")["countylists"])
                .replace(/countyid/g, "value")
                .replace(/countyname/g, "label")
        );
        let specialprovince = ["710000", "810000", "820000"]; // 港澳台province,city value一样cascader显示不出来
        specialprovince.forEach((item) => (citylists[item][0]["value"] += "1"));
        provinces.forEach((province) => {
            options.push({ value: province.subitem, label: province.subitemname });
            let cities = (options[options.length - 1]["children"] = citylists[province.subitem]);
            cities.forEach((city) => {
                city["children"] = countylists[city.value];
            });
        });
        return options;
    },
    // 用户号+生成16位随机数
    generateRandomNumber() {
        let randomNum = "";
        while (randomNum.length < 16) {
            randomNum += Math.floor(Math.random() * 10).toString();
        }

        return (cache.getUserOtherInfo().custno ? cache.getUserOtherInfo().custno : "") + randomNum;
    },

    copyText(that, text) {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select(); // 选中文本
        try {
            document.execCommand("copy");
            that.$message.success("复制成功");
        } catch (err) {
            console.error("复制失败：", err);
        }
        document.body.removeChild(textarea);
    }
};
